(() => {
  const menuToggle = document.querySelector("[data-menu-toggle]");
  const mobileNav = document.getElementById("MobileMenu");

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener("click", () => {
      const open = menuToggle.getAttribute("aria-expanded") === "true";
      menuToggle.setAttribute("aria-expanded", String(!open));
      mobileNav.hidden = open;
    });
  }

  const buyButtons = document.querySelectorAll(".js-buy-now");

  buyButtons.forEach((button) => {
    button.addEventListener("click", async () => {
      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;

      button.disabled = true;
      const original = button.innerHTML;
      button.textContent = "Redirecting to checkout…";

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
          }),
        });

        if (!response.ok) throw new Error("Could not add to cart");
        window.location.href = "/checkout";
      } catch (error) {
        button.disabled = false;
        button.innerHTML = original;
        window.location.href = "/cart";
      }
    });
  });
})();
